import Vue from 'vue';
import EasySlider from 'vue-easy-slider';
import VueScrollactive from 'vue-scrollactive';
import format from 'date-fns/format';
import App from './App';
import registerVuetify from './vuetify';
import { httpRequestInterceptor, httpResponseInterceptor, httpResponseSuccessInterceptor } from './http';
import registerAxios from './axios';
import vueRouter from './router';
import globalMixin from './mixins/global';
import registerFilters from './filters/global';
import './directives/global';


const router = vueRouter(Vue);
registerFilters(Vue);
registerVuetify(Vue);
registerAxios(Vue);
Vue.mixin(globalMixin);
Vue.prototype.$bus = new Vue();
Vue.prototype.$S3 = 'https://mibodega.s3-sa-east-1.amazonaws.com/';
Vue.prototype.$today = format(new Date(), 'YYYY/MM/DD');

Vue.use(EasySlider);
Vue.use(VueScrollactive);
// Vue.use(VueAwesomeSwiper);
/* eslint-disable no-new */
new Vue({
	el: '#app',
	methods: {
		httpRequestInterceptor,
		httpResponseInterceptor,
		httpResponseSuccessInterceptor,
	},
	router,
	render: h => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js